module.exports = __webpack_public_path__ + "static/ARTS_100-ae6639542e8c6bf5f100fb34013e22c5.png";